module.exports = __webpack_public_path__ + "static/media/logo-ezex.171774ed.png";